import React from 'react';
import { Navigation } from '../components/Navigation';
import { TrialOfferCTA } from '../components/TrialOfferCTA';
import { Footer } from '../components/Footer';
import { ResourcesHero } from './resources/ResourcesHero';
import { PoomsaeSection } from './resources/PoomsaeSection';
import { BeltTyingSection } from './resources/BeltTyingSection';
import { HomeRulesSection } from './resources/HomeRulesSection';
export function ResourcesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-746">
      <Navigation data-id="element-747" />
      <ResourcesHero data-id="element-748" />
      <PoomsaeSection data-id="element-749" />
      <BeltTyingSection data-id="element-750" />
      <HomeRulesSection data-id="element-751" />
      <TrialOfferCTA data-id="element-752" />
      <Footer data-id="element-753" />
    </div>;
}